const scheduledServicesUsersFilters = {
  usersFilters: "Filtros Usuarios",
  searchUsers: "Buscar Usuarios",
};

export default scheduledServicesUsersFilters;
